import { RouteName } from '@mews-commander/enums';
import { ResolveRoute } from '@mews/routing';

export const getTaskCreateUrl = (resolveRoute: ResolveRoute) => (serviceOrderId: string) =>
    resolveRoute(RouteName.TaskCreate, { query: { serviceOrderId } });

export const getTaskDetailUrl = (resolveRoute: ResolveRoute) => (taskId: string) =>
    resolveRoute(RouteName.TaskDetail, { taskId });
